import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkResult } from '@/shared/actions/thunk-result';

import { ISubmitFormResult, onboardingAPI } from '../api';
import { WelcomeForm } from '../model/welcomeStep';
import { namespace } from '../namespace';

let lastRequestId: string | undefined;

const submitWelcomeStep = createAsyncThunk(
  `${namespace}/submit-setup-user`,
  async (
    form: WelcomeForm,
    { requestId },
  ): Promise<ThunkResult<ISubmitFormResult<WelcomeForm>>> => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      const result = await onboardingAPI.submitWelcomeStep(form);
      // related driver will be created implicitly on the back-end

      return {
        isSucceed: true,
        result,
      };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { submitWelcomeStep };
